const networkToCoinMapping = {
    "XLM": "stellar",           
    "ERC-20": "ethereum",    
    "Arbitrum Sepolia": "ethereum", 
    "Base Sepolia": "ethereum", 
    "Holesky": "ethereum",       
    "BTC": "bitcoin",            
    "ALGO": "algorand",        
    "Cardano": "cardano",       
    // Add more mappings as necessary
  };
  export default networkToCoinMapping;